@switch (mediaService.media()) {
@case ('xs') {
<ng-container *ngTemplateOutlet="xsmode"></ng-container>
}
@case ('sm') {
<ng-container *ngTemplateOutlet="xsmode"></ng-container>
}
@case ('md') {
<ng-container *ngTemplateOutlet="xsmode"></ng-container>
}
@default {
<ng-container *ngTemplateOutlet="bigmode"></ng-container>
}
}

<ng-template #xsmode>
    <div class="tmp_srchwrpmobile" #globalsearch="cdkOverlayOrigin" cdkOverlayOrigin>
        <svg (click)="gotoSearch($event)" width="17" height="17" viewBox="0 0 17 17" fill="currentColor"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12.0056 6.99366C12.0056 5.21415 11.0364 3.59073 9.5044 2.68537C7.94113 1.78 6.03395 1.78 4.50195 2.68537C2.93869 3.59073 2.00073 5.21415 2.00073 6.99366C2.00073 8.80439 2.93869 10.4278 4.50195 11.3332C6.03395 12.2385 7.94113 12.2385 9.5044 11.3332C11.0364 10.4278 12.0056 8.80439 12.0056 6.99366ZM11.0364 12.1137C9.91084 12.9878 8.50391 13.4873 7.00318 13.4873C3.40767 13.4873 0.5 10.5839 0.5 6.99366C0.5 3.43463 3.40767 0.5 7.00318 0.5C10.5674 0.5 13.5064 3.43463 13.5064 6.99366C13.5064 8.52341 12.9748 9.92829 12.0994 11.0522L16.289 15.2044C16.5703 15.5166 16.5703 15.9849 16.289 16.2659C15.9763 16.578 15.5073 16.578 15.2259 16.2659L11.0364 12.1137Z"
                fill="currentColor" />
        </svg>

        <!-- <img src="../../../../assets/tvg/search_dark.svg"  /> -->
        <input type="text" class="tmpangebotsktvinputmobile" [formControl]="mySearchControl"
            placeholder="{{placeholder()}}" autocomplete="off" (keydown.enter)="gotoSearch($event)">
        @if(loading()) {
        <ng-container *ngTemplateOutlet="myloading"></ng-container>
        } @else if (mySearchControl.value?.length > 0) {
        <img src="../../../../assets/tvg/close.svg" (click)="mySearchControl.setValue('')" />
        }
        <!-- @else {
        <button class="tmp_srchbtn" (click)="gotoSearch($event)" aria-label="Search" matRipple>
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"
                fill="var(--cl-bg-color)">
                <path d="M0 0h24v24H0z" fill="none" />
                <path
                    d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
            </svg>
        </button>
        } -->
    </div>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="globalsearch"
        [cdkConnectedOverlayFlexibleDimensions]="true" (overlayOutsideClick)="showglobalsearchres.set(false)"
        [cdkConnectedOverlayOpen]="showglobalsearchres()">
        <div class="cc50wrappermobile">
            @if(searchres()?.length > 0) {
            <div class="cc50mobile customscroll" (scroll)="$event.stopPropagation()">
                @for (obj of searchres(); track $index) {
                <button class="cc50-itemmobile" (click)="gotofirst(obj, $event)">
                    <div class="cc51mobile">
                        @if(obj?.sktvbestellnummer?.length > 0) {
                        <div class="ccsjtv" [innerHtml]="obj.sktvbestellnummer | safehtml"></div>
                        }
                        <div class="cc50-title" [innerHtml]="obj.displayname | safehtml"></div>
                        @if(obj.subtext?.length > 0) {
                        <span class="cc50-item-subtext">{{obj.subtext}}</span>
                        }
                    </div>
                    <div class="cc52mobile">
                        @if(obj.isPauschal) {
                        <button class="cc53mobile" (click)="gotoPauschal(obj, $event)">{{'Pauschal' }}</button>
                        }
                        @if(obj.isHotelonly) {
                        <button class="cc53mobile" (click)="gotoHotel(obj, $event)">{{'Hotel'}}</button>
                        }
                        @if(obj.isRailtravel) {
                        <button class="cc53mobile" (click)="gotoRail(obj, $event)">{{'Bahn'}}
                            +
                            {{'Hotel' }}</button>
                        }
                        @if(obj.isFlight) {
                        <button class="cc53mobile" (click)="gotoFlight(obj, $event)">{{'Flug'}}</button>
                        }
                        @if(obj.isCarrent) {
                        <button class="cc53mobile" (click)="gotoCarrent(obj, $event)">{{'Mietwagen' }}</button>
                        }
                        @if(obj.isCruise) {
                        <button class="cc53mobile" (click)="gotoCruise(obj, $event)">{{'Kreuzfahrten' }}</button>
                        }
                        @if(obj.isFerienhauser) {
                        <button class="cc53mobile" (click)="gotoFerienhauser(obj, $event)">{{'Ferienhäuser' }}</button>
                        }
                        @if(obj.isContent) {
                        <button class="cc53mobile" (click)="gotoContent(obj, $event)">{{'Travelfacts' }}</button>
                        }
                        @if(obj.isTvangebote) {
                        <button class="cc53mobile" (click)="gotoSktv(obj, $event)">{{'TV-Angebote' }}</button>
                        }
                        @if(obj.isGolfplatz) {
                        <button class="cc53mobile" (click)="gotoGolfPlz(obj, $event)">{{'Golfplatz'}}</button>
                        }
                        @if(obj.isGolfHotels) {
                        <button class="cc53mobile" (click)="gotoGolfHotel(obj, $event)">{{'Golfhotel'}}</button>
                        }
                        @if(obj.isJtHotels) {
                        <button class="cc53mobile" (click)="gotoJtHotel(obj, $event)">{{'JT-Hotel'}}</button>
                        }
                    </div>
                </button>
                }
            </div>
            <div class="cc50footer">
                <button class="w100 custombutton" (click)="gotoSearch($event)" matRipple>weitere
                    Ergebnisseanzeigen</button>
            </div>
            } @else {
            <ng-container *ngTemplateOutlet="notfound"></ng-container>
            }
        </div>
    </ng-template>
</ng-template>

<ng-template #bigmode>
    <div class="tmp_body">
        <div class="tmp_srchwrp" #globalsearch="cdkOverlayOrigin" cdkOverlayOrigin>
            <input type="text" class="tmpangebotsktvinput" autocomplete="off" [formControl]="mySearchControl"
                placeholder="{{placeholder()}}" (keydown.enter)="gotoSearch($event)">
            @if(loading()) {
            <ng-container *ngTemplateOutlet="myloading"></ng-container>
            }
        </div>
    </div>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="globalsearch"
        [cdkConnectedOverlayFlexibleDimensions]="true" (overlayOutsideClick)="showglobalsearchres.set(false)"
        [cdkConnectedOverlayOpen]="showglobalsearchres()">
        <div class="cc50wrapper mat-elevation-z2">
            @if(searchres()?.length > 0) {
            <div class="cc50 customscroll">
                @for (obj of searchres(); track $index) {
                <button class="cc50-item" (click)="gotofirst(obj, $event)">
                    <div class="cc51">
                        @if(obj?.sktvbestellnummer?.length > 0) {
                        <div class="ccsjtv" [innerHtml]="obj.sktvbestellnummer | safehtml"></div>
                        }
                        <div class="cc50-title" [innerHtml]="obj.displayname | safehtml"></div>
                        @if(obj.subtext?.length > 0) {
                        <span class="cc50-item-subtext">{{obj.subtext}}</span>
                        }
                    </div>
                    <div class="cc52">
                        @if(obj.isPauschal) {
                        <button class="cc53" (click)="gotoPauschal(obj, $event)">Pauschal</button>
                        }
                        @if(obj.isHotelonly) {
                        <button class="cc53" (click)="gotoHotel(obj, $event)">Hotel</button>
                        }
                        @if(obj.isRailtravel) {
                        <button class="cc53" (click)="gotoRail(obj, $event)">{{'Bahn'}} +
                            {{'Hotel'}}</button>
                        }
                        @if(obj.isFlight) {
                        <button class="cc53" (click)="gotoFlight(obj, $event)">{{'Flug'}}</button>
                        }
                        @if(obj.isCarrent) {

                        <button class="cc53" (click)="gotoCarrent(obj, $event)">Mietwagen</button>
                        }
                        @if(obj.isCruise) {
                        <button class="cc53" (click)="gotoCruise(obj, $event)">Kreuzfahrten</button>
                        }
                        @if(obj.isFerienhauser) {
                        <button class="cc53" (click)="gotoFerienhauser(obj, $event)">{{'Ferienhäuser' }}</button>
                        }
                        @if(obj.isContent) {
                        <button class="cc53" (click)="gotoContent(obj, $event)">Travelfacts</button>
                        }
                        @if(obj.isTvangebote) {
                        <button class="cc53" (click)="gotoSktv(obj, $event)">TV-Angebote</button>
                        }
                        @if(obj.isGolfplatz) {
                        <button class="cc53" (click)="gotoGolfPlz(obj, $event)">Golfplatz'</button>
                        }
                        @if(obj.isGolfHotels) {
                        <button class="cc53" (click)="gotoGolfHotel(obj, $event)">Golfhotel</button>
                        }
                        @if(obj.isJtHotels) {
                        <button class="cc53" (click)="gotoJtHotel(obj, $event)">JT-Hotel</button>
                        }
                    </div>
                </button>
                }
            </div>
            <div class="cc50footer">
                <button class="custombutton" (click)="gotoSearch($event)">weitere Ergebnisse anzeigen</button>
            </div>
            } @else {
            <ng-container *ngTemplateOutlet="notfound"></ng-container>
            }
        </div>
    </ng-template>
</ng-template>


<ng-template #myloading>
    <mat-spinner [diameter]="22"></mat-spinner>
</ng-template>

<ng-template #notfound>
    <div class="cc54">{{'Keine Ergebnisse gefunden' }}</div>
</ng-template>